<template>
<div class="jumbotron jumbotron-fluid jumbotron-home">
    <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <h1 class="h1-forms">Rejestracja</h1>

                    <form id="f-register" @submit.prevent="handleRegisterForm()" method="post">
                        <div class="form-row">
                            <form-input label="Imię:" size="col-md-6" name="name" :modelValue="name" v-model="name" :error-messages="errorMessages"></form-input>
                            <form-input label="Nazwisko:" size="col-md-6" name="last_name" :modelValue="last_name" v-model="last_name" :error-messages="errorMessages"></form-input>
                        </div>
                        <form-input type="email" label="E-mail:" name="email" id="fr-email"  :modelValue="email" v-model="email" :error-messages="errorMessages"></form-input>

                        <div class="form-row">
                            <form-input label="Hasło:" size="col-md-6" type="password" name="password" id="fr-pwd" minlength="8" :modelValue="password" v-model="password" :error-messages="errorMessages" extraInfo="Hasło musi składać się przynajmniej z 8 znaków."></form-input>
                            <form-input label="Powtórz hasło:" size="col-md-6" type="password" name="password_confirm" id="fr-pwdr" minlength="8" :modelValue="password_confirm" v-model="password_confirm" :error-messages="errorMessages"></form-input>
                        </div>

                        <div class="form-row">
                            <form-select label="Wykonywany zawód:" size="col-md-6" name="profession" :modelValue="profession" v-model="profession" :error-messages="errorMessages" :values="JSON.parse(professions)"></form-select>
                            <form-input v-if="profession != 3 && profession != 6 && profession != 8 && profession != 9 && profession != 9  && profession != 12  && profession != 13" label="Podaj numer prawa wykonywania zawodu:" size="col-md-6" :modelValue="pwz_number" type="text" name="pwz_number" id="fr-pwz" maxlength="15" v-model="pwz_number" :error-messages="errorMessages"></form-input>
                        </div>

                        <div class="form-group" v-if="profession != 4 && profession != 6">
                            <form-textarea label="Miejsce pracy:" name="work_place" rows="3" :modelValue="work_place" v-model="work_place" :error-messages="errorMessages"></form-textarea>
                        </div>

                        <div class="form-row">
                            <form-input label="Telefon:" size="col-md-6" type="text" name="phone" :modelValue="phone" id="fr-phon" maxlength="50" v-model="phone" :error-messages="errorMessages"></form-input>
                            <form-input v-if="profession == 1" label="Specjalizacja:" size="col-md-6" :modelValue="specialization" type="text" name="specialization" id="fr-specs" maxlength="100" v-model="specialization" :error-messages="errorMessages"></form-input>
                            <form-input v-if="profession == 4" label="Uniwersytet:" size="col-md-6" :modelValue="university" type="text" name="university" v-model="university" :error-messages="errorMessages"></form-input>
                            <form-input v-if="profession == 4" label="Podaj numer legitymacji studenckej" size="col-md-6" type="text" :modelValue="card" name="card" v-model="card" :error-messages="errorMessages"></form-input>
                            <form-input v-if="profession == 6" label="Podaj firmę, której jesteś przedstawicielem:" size="col-md-6" :modelValue="company_represented" type="text" name="company_represented" v-model="company_represented" :error-messages="errorMessages"></form-input>
                        </div>

                        <div class="mt-3">
                            <form-user-agreement-input :require="1" :label="privacy_agreement_label" :modelValue="privacy_agreeement" v-model="privacy_agreeement" name="privacy_agreeement" :error-messages="errorMessages"></form-user-agreement-input>
                            <form-user-agreement-input :require="0" :label="marketing_agreement_label" :modelValue="marketing_agreeement" v-model="marketing_agreeement" name="marketing_agreeement" :error-messages="errorMessages"></form-user-agreement-input>
                        </div>

                        <div class="alert alert-danger" v-if="errorMessages">
                            <p>
                                Wystąpił błąd przetwarzania formularza, prosimy uzupełnić dane:
                            </p>

                            <ul>
                                <li v-for="error in errorMessages" v-html="error[0]"></li>
                            </ul>
                        </div>

                        <div class="form-group text-center">
                            <button type="submit" class="btn btn-primary btn-lg">Załóż konto</button>
                        </div>

                        <div class="form-links">
                            <a href="/logowanie">Masz już konto? Zaloguj się</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <notifications group="foo" />

</div>
</template>

<script>
    import FormInput from "./formInput";
    import FormSelect from "./formSelect";
    import FormTextarea from "./formTextarea";
    import Spinner from 'vue-simple-spinner';
    import FormUserType from "./formUserType";
    import FormAgreementInput from "./formAgreementInput";
    import FormUserAgreementInput from "./formUserAgreementInput";

    export default {
        props: ['agreement_inputs', 'professions', 'privacy_agreement_content', 'marketing_agreement_content', 'redirect_url'],

        components: {
            FormUserType,
            FormAgreementInput,
            FormInput,
            FormSelect,
            FormTextarea,
            FormUserAgreementInput,
            Spinner
        },
        data() {
            return {
                email: null,
                password: null,
                password_confirm: null,
                name: null,
                last_name: null,
                specialization: null,
                pwz_number: null,
                street: null,
                card: null,
                university: null,
                company_represented: null,
                user_type: 'person',
                work_place: null,
                agreements: [],
                errorMessages: null,
                successStatus: null,
                processing: false,
                profession: null,
                phone: null,
                specialAgreementInputs: [],
                privacy_agreeement: 0,
                marketing_agreeement: 0,
                privacy_agreement_label: this.privacy_agreement_content,
                marketing_agreement_label: this.marketing_agreement_content,
            }
        },

        methods: {
            handleRegisterForm() {
                axios.post('/api/register', {
                    email: this.email,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    name: this.name,
                    last_name: this.last_name,
                    profession: this.profession,
                    specialization: this.specialization,
                    pwz_number: this.pwz_number,
                    company_represented: this.company_represented,
                    street: this.street,
                    card: this.card,
                    university: this.university,
                    work_place: this.work_place,
                    agreements: this.agreements,
                    user_type: this.user_type,
                    phone: this.phone,
                    privacy_agreeement: this.privacy_agreeement,
                    marketing_agreeement: this.marketing_agreeement,
                })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = '/'+this.redirect_url;
                })
                .catch(error => {
                    this.errorMessages = error.response.data.errors;
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.message,
                    });
                }).then(error => {
                    window.scrollTo(0, document.querySelector('.error').offsetParent.offsetTop);
                });
            },
        }

    }
</script>
